<ng-container *transloco="let t">
  <div class="-mx-3 -mt-2 overflow-y-auto" tuiFade="vertical">
    <pxc-sadm-entity-select-list
      [emptyTemplate]="emptyState"
      [entities]="(displayEntities$ | async) ?? []"
      [loading]="(isDataLoaded$ | async) === false"
      [selectedId]="selectedSadmIdControl.value"
      (selectedIdChange)="selectedSadmIdControl.setValue($event)" />
  </div>

  @if (isDialog()) {
    <div class="flex justify-between gap-2 pt-6">
      @if ((displayEntities$ | async)?.length) {
        <pxc-sadm-client-action-button
          appearance="outline"
          data-testid="create-entity"
          icon="@tui.plus"
          size="m"
          [label]="t('Nouvelle lésion')"
          [sadmClients]="(sadms$ | async) ?? []"
          (clientSelected)="createEntity($event)" />
      }
      <div class="ml-auto flex gap-2">
        <button appearance="outline" data-testid="cancel-button" tuiButton type="button" (click)="close()">
          {{ t('Annuler') }}
        </button>
        <button
          data-testid="confirm-button"
          tuiButton
          type="button"
          [disabled]="selectedSadmIdControl.invalid"
          (click)="validate()">
          {{ t('Valider') }}
        </button>
      </div>
    </div>
  }

  <ng-template #emptyState>
    <pxc-empty-state
      class="col-span-full"
      icon="@tui.clipboard-list"
      [title]="t('Vous n\'avez aucune lésion pour ce patient.')">
      <pxc-sadm-client-action-button
        data-testid="create-entity-empty"
        icon="@tui.plus"
        size="m"
        [label]="t('Nouvelle lésion')"
        [sadmClients]="(sadms$ | async) ?? []"
        (clientSelected)="createEntity($event)" />
    </pxc-empty-state>
  </ng-template>
</ng-container>
